import { createSelector } from 'reselect';
import CPF from 'gerador-validador-cpf';

export const Types = {
  GET_REQUEST: 'participants/GET_REQUEST',
  GET_SUCCESS: 'participants/GET_SUCCESS',
  GET_FAILURE: 'participants/GET_FAILURE',

  GET_LIST_REQUEST: 'participants/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'participants/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'participants/GET_LIST_FAILURE',

  CREATE_REQUEST: 'participants/CREATE_REQUEST',
  CREATE_SUCCESS: 'participants/CREATE_SUCCESS',
  CREATE_FAILURE: 'participants/CREATE_FAILURE',

  UPDATE_REQUEST: 'participants/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'participants/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'participants/UPDATE_FAILURE',

  DELETE_REQUEST: 'participants/DELETE_REQUEST',
  DELETE_SUCCESS: 'participants/DELETE_SUCESS',
  DELETE_FAILURE: 'participants/DELETE_FAILURE',

  SEARCH_BY_DOCUMENT_REQUEST: 'participants/SEARCH_BY_DOCUMENT_REQUEST',
  SEARCH_BY_DOCUMENT_SUCCESS: 'participants/SEARCH_BY_DOCUMENT_SUCCESS',
  SEARCH_BY_DOCUMENT_FAILURE: 'participants/SEARCH_BY_DOCUMENT_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  total: 0,

  participant: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  searchByDocument: {
    data: [],
    loading: false,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        participant: {
          ...state.participant,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        participant: {
          ...state.participant,
          loading: false,
          data: action.payload.participant.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        participant: {
          ...state.participant,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.participants.data,
        page: action.payload.participants.meta.current_page,
        total: action.payload.participants.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    case Types.SEARCH_BY_DOCUMENT_REQUEST:
      return {
        ...state,
        searchByDocument: {
          ...state.searchByDocument,
          loading: true,
        },
      };
    case Types.SEARCH_BY_DOCUMENT_SUCCESS:
      return {
        ...state,
        searchByDocument: {
          ...state.searchByDocument,
          loading: false,
          data: action.payload.participants.data,
        },
      };
    case Types.SEARCH_BY_DOCUMENT_FAILURE:
      return {
        ...state,
        searchByDocument: {
          ...state.searchByDocument,
          data: [],
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getParticipantRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getParticipantSuccess: participant => ({
    type: Types.GET_SUCCESS,
    payload: { participant },
  }),

  getParticipantFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getParticipantsRequest: (page = 1, query = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, query },
  }),

  getParticipantsSuccess: participants => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { participants },
  }),

  getParticipantsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createParticipantRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createParticipantSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createParticipantFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateParticipantRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateParticipantSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateParticipantFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteParticipantRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteParticipantSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteParticipantFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  searchParticipantsByDocumentRequest: search => ({
    type: Types.SEARCH_BY_DOCUMENT_REQUEST,
    payload: { search },
  }),

  searchParticipantsByDocumentSuccess: participants => ({
    type: Types.SEARCH_BY_DOCUMENT_SUCCESS,
    payload: { participants },
  }),

  searchParticipantsByDocumentFailure: () => ({
    type: Types.SEARCH_BY_DOCUMENT_FAILURE,
  }),
};

export const Selectors = {
  list: createSelector(
    state => state,
    participants =>
      participants.map(participant => ({
        ...participant,
        attributes: {
          ...participant.attributes,
          cpf: CPF.format(participant.attributes.cpf),
        },
      })),
  ),

  search: createSelector(
    state => state,
    participants =>
      participants.map(participant => ({
        value: participant.id,
        label: `${participant.attributes.name} (${participant.attributes.email})`,
      })),
  ),
};



// WEBPACK FOOTER //
// ./src/store/ducks/participants.js